import {
    type DeleteBoardMemberResponseType,
    type DeleteBoardMemberRequestType
} from "./type";
import {
    request
} from "../request";

const deleteBoardMember = async (params: DeleteBoardMemberRequestType): Promise<DeleteBoardMemberResponseType> => {
    return await request<DeleteBoardMemberResponseType>("/content/deleteBoardMember", {
        body: JSON.stringify(params),
        method: "POST"
    });
};
export default deleteBoardMember;
